import { useState, useEffect } from 'react';
import DualListBox from '../../../components/reusables/dualListBox';
import ClientService from '../../../rest/clientService';
import { toast } from 'react-toastify';

const PermissionsTab = ({ users, allPermissions }) => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [userPermissions, setUserPermissions] = useState([]);

    const makeKey = (item) => `${item.resource}-${item.action}`;

    useEffect(() => {
        if (selectedUser) {
            setUserPermissions(selectedUser.permissions || []);
        } else {
            setUserPermissions([]);
        }
    }, [selectedUser]);

    const addPermission = (perm) => setUserPermissions((prev) => [...prev, perm]);
    const removePermission = (perm) => setUserPermissions((prev) => prev.filter((p) => makeKey(p) !== makeKey(perm)));

    const availablePermissions = allPermissions.filter(
        (p) => !userPermissions.some((up) => makeKey(up) === makeKey(p))
    );

    const savePermissions = async () => {
        if (!selectedUser) return;
        try {
            const permissionIds = userPermissions.map((p) => p.id);
            await ClientService.updateUserPermissions(selectedUser.id, permissionIds);
            toast.success("Permissões salvas com sucesso!");
        } catch (err) {
            console.error(err);
            toast.error("Erro ao salvar permissões!");
        }
    };

    return (
        <>
            <div className="flex flex-col mb-4">
                <label className="text-gray-700 font-semibold mb-2">Selecione o usuário:</label>
                <select
                    className="border rounded-xl px-4 py-2 w-full bg-white"
                    onChange={(e) => {
                        const user = users.find((u) => String(u.id) === e.target.value || u.login === e.target.value);
                        setSelectedUser(user || null);
                    }}
                >
                    <option value="">Selecione</option>
                    {users.map((user) => (
                        <option key={user.id ?? user.login} value={user.id ?? user.login}>
                            {user.name} ({user.login})
                        </option>
                    ))}
                </select>
            </div>

            {selectedUser && (
                <div className="flex flex-col md:flex-row gap-6">
                    <div className="flex-1 bg-white p-4 rounded-2xl shadow">
                        <DualListBox
                            leftItems={availablePermissions}
                            rightItems={userPermissions}
                            onAdd={addPermission}
                            onRemove={removePermission}
                            onSave={savePermissions}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default PermissionsTab;
